//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/reports/views/main/lan/en';
import overview from 'Modules/reports/views/overview/lan/en';

//Merge Components
import reportExportHistory from 'Modules/reports/.components/reportExportHistory/lan/en';

locales = { ...locales, ...main, ...overview, ...reportExportHistory };


export default locales;